import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectUpdateFileTypeStatus = createSelector(
  [(store: RootState) => store.fileTypes.updateFileTypeStatus],
  (data) => data
);